import React from 'react';
import { Mic, Camera, Monitor } from 'lucide-react';

const WelcomeStep = ({ isMobile }) => {
  return (
    <div className="flex flex-col items-center w-full justify-center">
      <h2 className={`${isMobile ? 'text-sm' : 'text-md'} font-semibold text-gray-900 ${isMobile ? 'mb-4' : 'mb-6'}`}>
        Welcome to Your Interview
      </h2>
      <div className={`${isMobile ? 'w-20 h-20' : 'w-24 h-24'} bg-gray-100 rounded-full flex items-center justify-center ${isMobile ? 'mb-4' : 'mb-6'}`}>
        <div className="flex flex-col gap-2 items-center text-indigo-600">
          <Mic size={isMobile ? 24 : 32} />
          <Camera size={isMobile ? 24 : 32} />
          <Monitor size={isMobile ? 24 : 32} />
        </div>
      </div>
      <p className={`${isMobile ? 'text-xs' : 'text-sm'} text-gray-600 ${isMobile ? 'mb-3' : 'mb-4'} max-w-2xl text-center px-2`}>
        Before we begin, we need to check a few technical requirements to ensure
        your interview goes smoothly. We'll need access to your:
      </p>
      <ul className={`text-left ${isMobile ? 'mb-4 space-y-1' : 'mb-6 space-y-2'} text-gray-700 max-w-md px-4`}>
        <li className={`flex items-center ${isMobile ? 'text-xs' : 'text-sm'}`}><span className="mr-2 text-indigo-500">•</span> Microphone - so the interviewer can hear you</li>
        <li className={`flex items-center ${isMobile ? 'text-xs' : 'text-sm'}`}><span className="mr-2 text-indigo-500">•</span> Camera - so the interviewer can see you</li>
        <li className={`flex items-center ${isMobile ? 'text-xs' : 'text-sm'}`}><span className="mr-2 text-indigo-500">•</span> Screen sharing - to demonstrate your skills</li>
      </ul>
      <p className={`${isMobile ? 'text-xs' : 'text-sm'} text-gray-800 font-medium`}>This will only take a minute. Let's get started!</p>
    </div>
  );
};

export default WelcomeStep;
